@use "../../styling/colors.scss" as *;
@use "../../styling/typography.scss" as *;

// Colors from https://xd.adobe.com/view/b0fe9c2e-f097-4795-ac8e-e4fee958c77c-e5ad/screen/1b44bf98-c121-4ced-8aa8-0cdfb6f7a9ff/

.TestResultLogItem {
  word-break: break-word;
  white-space: normal;
  font-family: $open-sans;
  color: $theme-color-text;
  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  display: block;

  // severity
  &.ALERT {
    color: $color-log-alert;
  }

  &.CRITICAL {
    color: $color-log-critical;
  }

  &.DEBUG {
    color: $color-log-debug;
  }

  &.EMERGENCY {
    color: $color-log-emergency;
  }

  &.ERROR {
    color: $color-log-error;
  }

  &.INFORMATIONAL {
    color: $theme-color-text;
  }

  &.NOTICE {
    color: $color-log-notice;
  }

  &.WARNING {
    color: $color-log-warning;
  }

  // stages, overrides severity
  &.SNIPPET {
    color: $color-log-snippet;
    padding-left: 1em;

    &.ERROR {
      color: $color-log-error;
    }
  }

  &.INITIALISING {
    color: $color-log-initialising;

    &.ERROR {
      color: $color-log-error;
    }
  }
}
